


export type FlowRoleOrigin = 'Manual' | 'DirectAssignment' | 'System';

export const FlowRoleOrigin = {
    Manual: 'Manual' as FlowRoleOrigin,
    DirectAssignment: 'DirectAssignment' as FlowRoleOrigin,
    System: 'System' as FlowRoleOrigin
};

